import { useEffect, useState } from 'react';
import apiClient from '../../api/apiClient';

const defaultNavigationPages = [
    { page_key: 'holidays', title: 'Holidays', slug: '/holidays-list' },
    { page_key: 'hotels', title: 'Hotels', slug: '/hotels-list' },
    { page_key: 'cabs', title: 'Cabs', slug: '/cabs-list' },
    { page_key: 'tirth-yatra', title: 'Tirtha Yatra', slug: '/yatra-list' },
    { page_key: 'medical-tourism', title: 'Medical Tourism', slug: '/medicaltourism' },
];

const iconClassByPageKey = {
    holidays: 'holidaymenuico',
    hotels: 'hotelmenuico',
    cabs: 'cabmenuico',
    'tirth-yatra': 'easydarshan-roico',
    'medical-tourism': 'visa-roicon2',
};

const normalizeNavigationPage = (page) => ({
    ...page,
    title: page.title || page.page_title,
    slug: page.slug || '/',
    iconClass: iconClassByPageKey[page.page_key] || 'holidaymenuico',
});

const useFrontendNavigationPages = () => {
    const [pages, setPages] = useState(defaultNavigationPages.map(normalizeNavigationPage));

    useEffect(() => {
        let mounted = true;

        apiClient.get('/web-pages/frontend-pages')
            .then((response) => {
                if (!mounted) return;
                const apiPages = response.data?.data || [];
                const orderedPages = defaultNavigationPages
                    .map((defaultPage) => apiPages.find((page) => page.page_key === defaultPage.page_key))
                    .filter(Boolean)
                    .map(normalizeNavigationPage);

                setPages(orderedPages.length ? orderedPages : defaultNavigationPages.map(normalizeNavigationPage));
            })
            .catch(() => {
                if (mounted) setPages(defaultNavigationPages.map(normalizeNavigationPage));
            });

        return () => {
            mounted = false;
        };
    }, []);

    return pages;
};

export default useFrontendNavigationPages;
